/**
 * BADD Postscript Ticket Tracking
 *
 * Purpose:
 * - Does NOT install/inject the Postscript SDK.
 * - Assumes the Postscript Shopify app embed already loads sdk.postscript.io.
 * - Scrapes ticket table rows to find variant IDs from /cart/{variant_id}:1 links.
 * - Fires one Postscript page_view event for browse abandonment.
 * - Optionally tracks Buy Now clicks as add_to_cart, disabled by default.
 *
 * Expected Liquid/global config before this file loads:
 * window.BADD_POSTSCRIPT_TICKET_CONFIG = {
 *   enabled: true,
 *   shopId: 798717,
 *   productId: 8007446691894,
 *   productTitle: "Giveaway Ticket - 2 for 1",
 *   vendor: "BADD Development",
 *   category: "Ticket",
 *   enableBrowse: true,
 *   enableAddToCart: false,
 *   debug: true
 * };
 */
(function (window, document) {
  "use strict";

  if (window.__BADD_POSTSCRIPT_TICKET_TRACKING_LOADED__) {
    return;
  }

  window.__BADD_POSTSCRIPT_TICKET_TRACKING_LOADED__ = true;

  var DEFAULTS = {
    enabled: false,
    shopId: null,
    productId: null,
    productTitle: document.title || "BADD Tickets",
    vendor: "BADD Worldwide",
    category: "Tickets",
    tableSelector: ".ticket-table",
    cartLinkSelector: 'a[href*="/cart/"]',
    enableBrowse: true,
    enableAddToCart: false,
    debug: false,
    waitAttempts: 24,
    waitIntervalMs: 250,
    defaultVariantStrategy: "first", // currently supports: first
    variantMap: {} // Optional: { "44362700488758": { title: "2", price_in_cents: 3000, sku: "ticket-2-2" } }
  };

  function log() {
    if (!CONFIG.debug || !window.console) return;
    window.console.log.apply(window.console, arguments);
  }

  function warn() {
    if (!window.console) return;
    window.console.warn.apply(window.console, arguments);
  }

  function mergeConfig(defaults, overrides) {
    var output = {};
    var key;

    overrides = overrides || {};

    for (key in defaults) {
      if (Object.prototype.hasOwnProperty.call(defaults, key)) {
        output[key] = defaults[key];
      }
    }

    for (key in overrides) {
      if (Object.prototype.hasOwnProperty.call(overrides, key)) {
        output[key] = overrides[key];
      }
    }

    return output;
  }

  var CONFIG = mergeConfig(DEFAULTS, window.BADD_POSTSCRIPT_TICKET_CONFIG);

  function toNumber(value) {
    if (value === null || typeof value === "undefined" || value === "") {
      return null;
    }

    var number = Number(value);
    return Number.isFinite(number) ? number : null;
  }

  function moneyToCents(text) {
    if (!text) return null;

    var numberText = String(text).replace(/[^0-9.]/g, "");
    if (!numberText) return null;

    var number = parseFloat(numberText);
    return Number.isFinite(number) ? Math.round(number * 100) : null;
  }

  function getVariantFromCartUrl(href) {
    if (!href) return null;

    // Supports both absolute and relative Shopify cart permalink URLs:
    // /cart/44362700488758:1
    // https://baddworldwide.org/cart/44362700488758:1
    var match = String(href).match(/\/cart\/(\d+):(\d+)/);
    if (!match) return null;

    return {
      variant_id: toNumber(match[1]),
      quantity: toNumber(match[2])
    };
  }

  function cleanTicketsText(cell) {
    if (!cell) return "";

    var clone = cell.cloneNode(true);
    var strike = clone.querySelector(".strikethrough_ticket_number");

    if (strike) {
      strike.remove();
    }

    return clone.textContent.trim().replace(/\s+/g, " ");
  }

  function getSearchParamsObject(extra) {
    var params = {};
    var searchParams = new URLSearchParams(window.location.search);

    searchParams.forEach(function (value, key) {
      params[key] = value;
    });

    if (extra) {
      Object.keys(extra).forEach(function (key) {
        params[key] = extra[key];
      });
    }

    return params;
  }

  function scrapeTicketRows() {
    var rows = document.querySelectorAll(CONFIG.tableSelector + " tbody tr");
    var tickets = [];

    rows.forEach(function (row, index) {
      var cells = row.querySelectorAll("td");
      var link = row.querySelector(CONFIG.cartLinkSelector);

      if (!cells.length || !link) return;

      var cartData = getVariantFromCartUrl(link.getAttribute("href"));
      if (!cartData || !cartData.variant_id) return;

      var variantMeta = CONFIG.variantMap[String(cartData.variant_id)] || {};
      var ticketsText = cleanTicketsText(cells[0]);
      var rowPriceInCents = moneyToCents(cells[1] ? cells[1].textContent : "");

      tickets.push({
        index: index,
        tickets: ticketsText,
        price_text: cells[1] ? cells[1].textContent.trim() : "",
        price_in_cents: toNumber(variantMeta.price_in_cents) || rowPriceInCents,
        variant_id: cartData.variant_id,
        cart_quantity: cartData.quantity,
        variant_title: variantMeta.title || ticketsText + " Tickets",
        sku: variantMeta.sku || null,
        href: link.href,
        row: row,
        link: link
      });
    });

    return tickets;
  }

  function waitForPostscript(callback, attempts) {
    attempts = attempts || 0;

    if (window.postscript && typeof window.postscript.event === "function") {
      callback();
      return;
    }

    if (attempts >= CONFIG.waitAttempts) {
      warn("[BADD/Postscript] SDK not ready. Event not fired.");
      return;
    }

    window.setTimeout(function () {
      waitForPostscript(callback, attempts + 1);
    }, CONFIG.waitIntervalMs);
  }

  function buildPayload(eventType, option) {
    var shopId = toNumber(CONFIG.shopId);
    var productId = toNumber(CONFIG.productId);

    return {
      shop_id: shopId,
      url: window.location.href,
      search_params: getSearchParamsObject({
        variant: String(option.variant_id),
        badd_event_source: eventType
      }),
      page_type: "product",
      referrer: document.referrer || null,
      resource: {
        category: CONFIG.category,
        product_title: CONFIG.productTitle,
        variant_title: option.variant_title,
        price_in_cents: option.price_in_cents,
        resource_id: productId,
        resource_type: "product",
        sku: option.sku,
        variant_id: option.variant_id,
        vendor: CONFIG.vendor
      }
    };
  }

  function validateConfig() {
    if (!CONFIG.enabled) {
      log("[BADD/Postscript] Tracking disabled by config.");
      return false;
    }

    if (!toNumber(CONFIG.shopId)) {
      warn("[BADD/Postscript] Missing or invalid shopId.");
      return false;
    }

    if (!toNumber(CONFIG.productId)) {
      warn("[BADD/Postscript] Missing or invalid productId.");
      return false;
    }

    return true;
  }

  function chooseDefaultOption(ticketOptions) {
    if (!ticketOptions.length) return null;

    // Future strategies can be added here, e.g. highest price, URL query variant, etc.
    return ticketOptions[0];
  }

  function fireBrowseEvent(ticketOptions) {
    var defaultOption = chooseDefaultOption(ticketOptions);

    if (!defaultOption) {
      warn("[BADD/Postscript] No ticket rows found. Browse event not fired.");
      return;
    }

    var payload = buildPayload("page_view", defaultOption);

    window.postscript.event("page_view", payload);

    log("[BADD/Postscript] page_view fired", {
      product_id: payload.resource.resource_id,
      variant_id: payload.resource.variant_id,
      price_in_cents: payload.resource.price_in_cents,
      variant_title: payload.resource.variant_title
    });
  }

  function attachBuyNowTracking(ticketOptions) {
    ticketOptions.forEach(function (option) {
      if (!option.link) return;

      // pointerdown gives the browser a moment to fire before the cart permalink navigates.
      option.link.addEventListener("pointerdown", function () {
        if (!window.postscript || typeof window.postscript.event !== "function") {
          return;
        }

        var payload = buildPayload("add_to_cart", option);
        window.postscript.event("add_to_cart", payload);

        log("[BADD/Postscript] add_to_cart fired", {
          product_id: payload.resource.resource_id,
          variant_id: payload.resource.variant_id,
          price_in_cents: payload.resource.price_in_cents,
          variant_title: payload.resource.variant_title
        });
      });
    });
  }

  function init() {
    if (!validateConfig()) return;

    waitForPostscript(function () {
      var ticketOptions = scrapeTicketRows();

      if (CONFIG.enableBrowse) {
        fireBrowseEvent(ticketOptions);
      }

      if (CONFIG.enableAddToCart) {
        attachBuyNowTracking(ticketOptions);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})(window, document);
